import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { activateCards } from '../api/rsimActionsApi.ts';

export const useRSimActivateMutation = (
  options?: Omit<UseMutationOptions<void, Error, { euiccIds: string[] }, unknown>, 'mutationFn'>,
) => {
  return useMutation({
    ...options,
    mutationFn: (params) => {
      return activateCards(params);
    },
  });
};
